import React from 'react';

const folderConfig = {
  inbox: { icon: 'IN', label: 'Odebrane', color: 'var(--info)' },
  sent: { icon: 'OUT', label: 'Wyslane', color: 'var(--purple)' },
  all: { icon: 'ALL', label: 'Wszystkie', color: 'var(--text-muted)' }
};

const priorityConfig = {
  pilny: { text: 'var(--danger)', label: 'Pilny' },
  wazny: { text: 'var(--warning)', label: 'Wazny' },
  normalny: { text: 'var(--info)', label: 'Normalny' }
};

const MessagesSidebar = ({ selectedFolder, setSelectedFolder, stats, isAdmin }) => {
  return (
    <div style={{ width: '220px', flexShrink: 0 }}>
      {/* Folders */}
      <div style={{ backgroundColor: "var(--card-bg)", borderRadius: '6px', border: '1px solid var(--border)', padding: '12px', marginBottom: '12px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Foldery
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {Object.entries(folderConfig).map(([key, cfg]) => {
            if (key === 'all' && !isAdmin) return null;
            return (
              <button
                key={key}
                onClick={() => setSelectedFolder(key)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '8px',
                  padding: '6px 12px',
                  backgroundColor: selectedFolder === key ? 'var(--primary-light)' : 'transparent',
                  color: selectedFolder === key ? 'var(--primary)' : 'var(--text-secondary)',
                  cursor: 'pointer', textAlign: 'left', fontSize: '12px',
                  fontWeight: selectedFolder === key ? 600 : 400
                }}
              >
                <span style={{ fontSize: '10px', color: cfg.color }}>{cfg.icon}</span>
                <span>{cfg.label}</span>
                {key === 'inbox' && stats?.unread_count > 0 && (
                  <span style={{ marginLeft: 'auto', border: '1px solid var(--danger)', color: 'var(--danger)' , padding: '1px 6px', borderRadius: '10px', fontSize: '10px', fontWeight: 600 }}>
                    {stats.unread_count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Priority legend */}
      <div style={{ backgroundColor: "var(--card-bg)", borderRadius: '6px', border: '1px solid var(--border)', padding: '12px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Priorytet
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {Object.entries(priorityConfig).map(([key, cfg]) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', fontSize: '12px', color: 'var(--text-secondary)' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: cfg.text }} />
              <span>{cfg.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MessagesSidebar;
